<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-8 font-size-16">({{total}}) Propriedades cadastrados</div>
            <div class="col-3">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="searchQuery"
                placeholder="Procurar..."
              />
            </div>
            <div class="col-1">
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="onHandleEdit(false)"
              >Criar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped mb-0 table-bordered">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th width="200">Alias</th>
                  <th width="200">Tipo</th>
                  <th width="200">Valores</th>
                  <th width="40">-</th>
                  <th width="40">-</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(propertie, index) in paginatedFilteredItems" v-bind:key="index">
                  <td>{{propertie.name}}</td>
                  <td>{{propertie.old_id}}</td>
                  <td>{{propertie.type.name}}</td>
                  <td v-if="propertieType(propertie.values) > 0">
                    <span
                      v-for="(pv, ii) in JSON.parse(propertie.values)"
                      v-bind:key="`${index}-${ii}`"
                      class="my-badge color-box tag-1"
                      :class="`tag-${ii}`"
                    >{{pv.name}}</span>
                  </td>
                  <td v-else></td>
                  <td>
                    <button
                      type="button"
                      class="btn-theme-circle bg-primary width-xs waves-effect waves-light"
                      @click="onHandleEdit(propertie.id)"
                    >
                      <i class="mdi mdi-pencil-outline font-size-14 align-middle"></i>
                    </button>
                  </td>
                  <td>
                    <app-button-delete-confirm @handle="onHandleDelete(propertie.id)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7">Página {{ currentPage }} de {{ totalPages }}</div>
    <div class="col-5">
      <div class="btn-group float-end">
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="prevPage"
          :disabled="currentPage === 1"
        >
          <i class="fa fa-chevron-left"></i>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import { mapActions } from "vuex";
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppButtonDeleteConfirm
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: ""
    };
  },
  computed: {
    filteredItems() {
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        return this.items.filter(item =>
          item.name.toLowerCase().includes(query)
        );
      }
      return this.items; // Garantir sempre que retorna um array
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    },
    paginatedFilteredItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredItems.slice(start, end); // Assegure que filteredItems é um array
    },
    total() {
      return Object.keys(this.items).length;
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1; // Redefine para a primeira página quando o filtro é alterado
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    onHandleEdit(id) {
      this.$emit("handle", id);
    },
    onHandleDelete(id) {
      this.$emit("handle2", id);
      const _this = this;
      let headers = _this.$getAPIHeaders("DELETE", `propertie/${id}`);
      this.axios(headers)
        .then(function(response) {
          console.log("response.data.message");
          _this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
        })
        .catch(function(error) {
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    removerItemPorId(id) {
      const index = this.items.findIndex(item => item.id === id);
      if (index !== -1) {
        this.items.splice(index, 1);
        console.log("removido");
      }
    },
    propertieType(values) {
      return Object.keys(JSON.parse(values)).length;
    }
  }
};
</script>
<style scoped>
.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
}

.my-badge {
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin: 3px 5px 0px 0px;
  display: inline-block;
  padding: 4px 6px;
  line-height: 1;
  max-width: 100%;
  text-wrap: nowrap;
  overflow: hidden;

}
</style>